import React, { useState, useEffect } from "react";
import { savePedido } from '../../services/PedidosService';

export default function Checkout() {
    const [notification, setNotification] = useState({});
    const [carrinho, setCarrinho] = useState([]);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [endereco, setEndereco] = useState("");
    const [compraFinalizada, setCompraFinalizada] = useState(false);

    const [total, setTotal] = useState(0);
    useEffect(() => {
        const carrinhoSalvo = localStorage.getItem("carrinho");
        if (carrinhoSalvo) {
            setCarrinho(JSON.parse(carrinhoSalvo));
        }
    }, []);

    const calcularTotal = () => {
        return carrinho.reduce((total, item) => total + item.preco * item.quantidade, 0).toFixed(2);
    };

    const finalizarCompra = () => {
        if (!nome || !email || !endereco) {
            alert("Por favor, preencha todos os campos.");
            return;
        }


        // Calcula o total e atualiza o estado
        const totalCompra = calcularTotal();
        setTotal(totalCompra);
        console.log("Total da compra:", totalCompra);


        // Cria o objeto do pedido a ser persistido
        const newPedido = {
            userId: 5,
            isPago: true,
            isProcessado: false,
            isEntregue: false,
            isActive: true,
            //  endereco,
            valor_total: totalCompra,
            // itens: carrinho,
            // data: new Date().toISOString(),
        };


        // Obtém o token do localStorage
        const token = localStorage.getItem("token");


        // Chama o serviço para persistir o pedido
        savePedido(null, newPedido, token)
            .then(result => {
                //  btnClose.current.click();
                if (result)
                    setNotification({ type: 'success', text: `Settings updated successfully!` });
                else
                    setNotification({ type: 'error', text: `Can't update the settings.` });
                //    btnClose.current.click();
                //  if (props.onSubmit) props.onSubmit(result);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                // setError(err.response ? err.response.data : err.message);
            })
        // Simula um pagamento bem-sucedido
        alert("Compra finalizada com sucesso! Obrigado por comprar conosco!");

        // Limpa o carrinho após o checkout
        localStorage.removeItem("carrinho");
        setCarrinho([]);
        setCompraFinalizada(true);
    };

    if (compraFinalizada) {
        return (
            <div className="container mt-5 text-center">
                <h1>🎉 Compra Realizada!</h1>
                <p>Obrigado por comprar conosco.</p>
                <a href="/loja" className="btn btn-primary">Voltar para a Loja</a>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">💳 Checkout</h1>

            {carrinho.length === 0 ? (
                <div className="text-center">
                    <p>Seu carrinho está vazio.</p>
                    <a href="/loja" className="btn btn-primary">Voltar para a Loja</a>
                </div>
            ) : (
                <div>
                    <div className="mb-3">
                        <label className="form-label">Nome Completo</label>
                        <input
                            type="text"
                            className="form-control"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Endereço de Entrega</label>
                        <input
                            type="text"
                            className="form-control"
                            value={endereco}
                            onChange={(e) => setEndereco(e.target.value)}
                            required
                        />
                    </div>

                    <h3 className="text-center mt-4">
                        Total a Pagar: <span className="text-success">R$ {calcularTotal()}</span>
                    </h3>

                    <div className="text-center mt-4">
                        <button className="btn btn-success btn-lg" onClick={finalizarCompra}>
                            ✅ Confirmar Pagamento
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
